export const editorOptions = {
  height: 300,
  buttonList: [
    ["undo", "redo"],
    [
      "bold",
      "underline",
      "italic",
      "strike",
      "font",
      "fontSize",
      "underline",
      "image",
    ],
    ["removeFormat", "link"],
    ["fontColor", "hiliteColor"],
    ["align", "horizontalRule", "list"],
    ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"],
  ],
  imageUploadUrl: "",
  font: [
    "Roboto",
    "Helvetica",
    "Arial",
    "sans-serif",
    "Comic Sans MS",
    "Courier New",
    "Impact",
    "Georgia",
    "Tahoma",
    "Trebuchet MS",
    "Verdana",
    "Logical",
    "Salesforce Sans",
    "Garamond",
    "Times New Roman",
  ],
  fontSize: [12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
  colorList: [
    [
      "#828282",
      "#FF5400",
      "#676464",
      "#F1F2F4",
      "#FF9B00",
      "#F00",
      "#fa6e30",
      "#000",
      "#FF6600",
      "#0099FF",
      "#74CC6D",
      "#FF9900",
      "#CCCCCC",
    ],
  ],
  attributesWhitelist: {
    all: ["style", "class", "id", "href", "target", "src", "rel"],
  },
  iframe: false,
  iframeAutoHeight: false,
};
